import { OnboardingType } from "@/src/constants/onboardingContents";

const ONBOARDING_KEY = 'onboarding_dont_show';

interface OnboardingData {
  [type: string]: boolean;
}

export const markOnboardingDontShow = (type: OnboardingType): void => {
  const data = getOnboardingData();
  data[type] = true;
  localStorage.setItem(ONBOARDING_KEY, JSON.stringify(data));
};

export const shouldShowOnboarding = (type: OnboardingType): boolean => {
  const data = getOnboardingData();
  return !data[type];
};

export const clearOnboardingStatus = (type?: OnboardingType): void => {
  if (type) {
    const data = getOnboardingData();
    delete data[type];
    localStorage.setItem(ONBOARDING_KEY, JSON.stringify(data));
  } else {
    localStorage.removeItem(ONBOARDING_KEY);
  }
};

const getOnboardingData = (): OnboardingData => {
  try {
    const stored = localStorage.getItem(ONBOARDING_KEY);
    return stored ? JSON.parse(stored) : {};
  } catch {
    return {};
  }
};

// 개발용 디버그 함수 - 프로덕션에서는 사용하지 마세요
export const debugOnboarding = {
  showAll: () => clearOnboardingStatus(),
  hideAll: () => {
    const allTypes: OnboardingType[] = ['contract', 'booking', 'loading', 'shipping', 'file', 'partner', 'supply', 'importStatus'];
    allTypes.forEach(type => markOnboardingDontShow(type));
  },
  getStatus: () => getOnboardingData()
};